module.exports = __webpack_public_path__ + "img/open-account-logout.9dc92d05.svg";